// @ts-nocheck
import React from 'react';
import { dynamic } from 'dumi';

export default {
  'auto-complete-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _turingUi = require("turing-ui");

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)(""),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var vehicleMakeOptions = [{
      name: "Acura",
      value: "Acura",
      label: "Acura"
    }, {
      name: "Audi",
      value: "Audi",
      label: "Audi"
    }, {
      name: "BMW",
      value: "BMW",
      label: "BMW"
    }, {
      name: "Buick",
      value: "Buick",
      label: "Buick"
    }, {
      name: "Chevrolet",
      value: "Chevrolet",
      label: "Chevrolet"
    }, {
      name: "Chrysler",
      value: "Chrysler",
      label: "Chrysler"
    }, {
      name: "Dodge",
      value: "Dodge",
      label: "Dodge"
    }, {
      name: "FIAT",
      value: "FIAT",
      label: "FIAT"
    }, {
      name: "Ford",
      value: "Ford",
      label: "Ford"
    }, {
      name: "Honda",
      value: "Honda",
      label: "Honda"
    }, {
      name: "Hyundai",
      value: "Hyundai",
      label: "Hyundai"
    }, {
      name: "Mazda",
      value: "Mazda",
      label: "Mazda"
    }, {
      name: "Mercedes-Benz",
      value: "Mercedes-Benz",
      label: "Mercedes-Benz"
    }, {
      name: "Mitsubishi",
      value: "Mitsubishi",
      label: "Mitsubishi"
    }, {
      name: "Nissan",
      value: "Nissan",
      label: "Nissan"
    }, {
      name: "Toyota",
      value: "Toyota",
      label: "Toyota"
    }, {
      name: "Volkswagen",
      value: "Volkswagen",
      label: "Volkswagen"
    }, {
      name: "Volvo",
      value: "Volvo",
      label: "Volvo"
    }];
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: 300
      }
    }, /*#__PURE__*/_react["default"].createElement(_turingUi.Autocomplete, {
      onChange: function onChange(v) {
        return setState(v);
      },
      value: state,
      size: "small",
      options: vehicleMakeOptions,
      placeholder: "Search vehicle make"
    }));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { Autocomplete } from \"turing-ui\";\n\nexport default () => {\n  const [state, setState] = useState(\"\");\n\n  const vehicleMakeOptions = [\n    { name: \"Acura\", value: \"Acura\", label: \"Acura\" },\n    { name: \"Audi\", value: \"Audi\", label: \"Audi\" },\n    { name: \"BMW\", value: \"BMW\", label: \"BMW\" },\n    { name: \"Buick\", value: \"Buick\", label: \"Buick\" },\n    { name: \"Chevrolet\", value: \"Chevrolet\", label: \"Chevrolet\" },\n    { name: \"Chrysler\", value: \"Chrysler\", label: \"Chrysler\" },\n    { name: \"Dodge\", value: \"Dodge\", label: \"Dodge\" },\n    { name: \"FIAT\", value: \"FIAT\", label: \"FIAT\" },\n    { name: \"Ford\", value: \"Ford\", label: \"Ford\" },\n    { name: \"Honda\", value: \"Honda\", label: \"Honda\" },\n    { name: \"Hyundai\", value: \"Hyundai\", label: \"Hyundai\" },\n    { name: \"Mazda\", value: \"Mazda\", label: \"Mazda\" },\n    { name: \"Mercedes-Benz\", value: \"Mercedes-Benz\", label: \"Mercedes-Benz\" },\n    { name: \"Mitsubishi\", value: \"Mitsubishi\", label: \"Mitsubishi\" },\n    { name: \"Nissan\", value: \"Nissan\", label: \"Nissan\" },\n    { name: \"Toyota\", value: \"Toyota\", label: \"Toyota\" },\n    { name: \"Volkswagen\", value: \"Volkswagen\", label: \"Volkswagen\" },\n    { name: \"Volvo\", value: \"Volvo\", label: \"Volvo\" },\n  ];\n\n  return (\n    <div style={{ width: 300 }}>\n      <Autocomplete\n        onChange={(v) => setState(v)}\n        value={state}\n        size=\"small\"\n        options={vehicleMakeOptions}\n        placeholder=\"Search vehicle make\"\n      />\n    </div>\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"turing-ui":{"version":"1.0.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.11.3"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.12.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"auto-complete","identifier":"auto-complete-demo"},
  },
  'button-groups-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _turingUi = require("turing-ui");

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)("1h"),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        dateType = _useState2[0],
        setDateType = _useState2[1];

    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: 120
      }
    }, /*#__PURE__*/_react["default"].createElement(_turingUi.ButtonGroups, {
      options: [{
        label: "1h",
        value: "1h"
      }, {
        label: "15m",
        value: "15m"
      }],
      value: dateType,
      onChange: function onChange(v) {
        return setDateType(v);
      },
      minWidth: 50
    }));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { ButtonGroups } from \"turing-ui\";\n\nexport default () => {\n  const [dateType, setDateType] = useState(\"1h\");\n\n  return (\n    <div style={{ width: 120 }}>\n      <ButtonGroups\n        options={[\n          { label: \"1h\", value: \"1h\" },\n          { label: \"15m\", value: \"15m\" },\n        ]}\n        value={dateType}\n        onChange={(v) => setDateType(v as string)}\n        minWidth={50}\n      />\n    </div>\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"turing-ui":{"version":"1.0.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.11.3"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.12.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"button-groups","identifier":"button-groups-demo"},
  },
  'confirm-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _react = _interopRequireDefault(require("react"));

  var _turingUi = require("turing-ui");

  var _core = require("@material-ui/core");

  var _default = function _default() {
    var handleConfirm = function handleConfirm() {
      _turingUi.confirm.confirm({
        title: "Confirm title",
        content: "Please make sure to obtain any required consents and ensure your compliance with all applicable laws while using this functionality.",
        okText: "Confirm",
        onOk: function onOk() {
          console.log("ok");
        },
        cancelText: "Cancel"
      });
    };

    return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: handleConfirm
    }, "Confirm")));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { confirm } from \"turing-ui\";\nimport { Grid, Button } from \"@material-ui/core\";\n\nexport default () => {\n  const handleConfirm = () => {\n    confirm.confirm({\n      title: \"Confirm title\",\n      content:\n        \"Please make sure to obtain any required consents and ensure your compliance with all applicable laws while using this functionality.\",\n      okText: \"Confirm\",\n      onOk: () => {\n        console.log(\"ok\");\n      },\n      cancelText: \"Cancel\",\n    });\n  };\n\n  return (\n    <Grid container>\n      <Grid item>\n        <Button onClick={handleConfirm}>Confirm</Button>\n      </Grid>\n    </Grid>\n  );\n};"}},"dependencies":{"react":{"version":"^16.8.0 || ^17.0.0"},"turing-ui":{"version":"1.0.0"},"@material-ui/core":{"version":"^4.11.3"},"@date-io/moment":{"version":"1.x"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.8.0 || ^17.0.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"},"@types/react":{"version":"^16.8.6 || ^17.0.0"}},"componentName":"confirm","identifier":"confirm-demo"},
  },
  'date-range-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _turingUi = require("turing-ui");

  var _moment = _interopRequireDefault(require("moment"));

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)(),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: 120
      }
    }, /*#__PURE__*/_react["default"].createElement(_turingUi.DateRange, {
      preLabel: "Date",
      value: state,
      label: "Time" // hasNoYear
      ,
      rangeValid: [(0, _moment["default"])().subtract(29, "days"), (0, _moment["default"])()] // timeDisable
      ,
      onChange: function onChange(v) {
        return setState(v);
      }
    }));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { DateRange } from \"turing-ui\";\nimport moment from \"moment\";\n\nexport default () => {\n  const [state, setState] = useState<any>();\n\n  return (\n    <div style={{ width: 120 }}>\n      <DateRange\n        preLabel=\"Date\"\n        value={state}\n        label=\"Time\"\n        // hasNoYear\n        rangeValid={[moment().subtract(29, \"days\"), moment()]}\n        // timeDisable\n        onChange={(v) => setState(v)}\n      />\n    </div>\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"turing-ui":{"version":"1.0.0"},"moment":{"version":"^2.29.1"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.11.3"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"react-dom":{"version":"^16.12.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"date-range","identifier":"date-range-demo"},
  },
  'empty-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _react = _interopRequireDefault(require("react"));

  var _turingUi = require("turing-ui");

  var _default = function _default() {
    var image = "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Finews.gtimg.com%2Fnewsapp_bt%2F0%2F14104391809%2F641&refer=http%3A%2F%2Finews.gtimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1637823361&t=74c09afea452055ec7f6e8f584a4bbfc";
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_turingUi.Empty, null), /*#__PURE__*/_react["default"].createElement(_turingUi.Empty, {
      image: image,
      imageStyle: {
        width: 60
      },
      description: /*#__PURE__*/_react["default"].createElement("span", null, "Customize ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "#API"
      }, "Description"))
    }));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { Empty } from \"turing-ui\";\n\nexport default () => {\n  const image =\n    \"https://gimg2.baidu.com/image_search/src=http%3A%2F%2Finews.gtimg.com%2Fnewsapp_bt%2F0%2F14104391809%2F641&refer=http%3A%2F%2Finews.gtimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1637823361&t=74c09afea452055ec7f6e8f584a4bbfc\";\n\n  return (\n    <>\n      <Empty />\n      <Empty\n        image={image}\n        imageStyle={{ width: 60 }}\n        description={\n          <span>\n            Customize <a href=\"#API\">Description</a>\n          </span>\n        }\n      />\n    </>\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"turing-ui":{"version":"1.0.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.11.3"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.12.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"empty","identifier":"empty-demo"},
  },
  'hls-player-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _core = require("@material-ui/core");

  var _turingUi = require("turing-ui");

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)("https://test-guard.turingvideo.com/livestreaming/hls/4826/6b06ed3657da4df1b16f9b0ed80c249f/index.m3u8"),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        url = _useState2[0],
        setUrl = _useState2[1];

    var _useState3 = (0, _react.useState)("https://test-guard.turingvideo.com/livestreaming/hls/4826/6b06ed3657da4df1b16f9b0ed80c249f/index.m3u8"),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        input = _useState4[0],
        setInput = _useState4[1];

    var handleInputChange = function handleInputChange(e) {
      var value = e.target.value;
      setInput(value);
    };

    var handleUrl = function handleUrl() {
      setUrl("");
      setTimeout(function () {
        setUrl(input);
      }, 3000);
    };

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
      variant: "outlined",
      style: {
        width: 800
      },
      value: input,
      onChange: handleInputChange
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      variant: "contained",
      color: "primary",
      style: {
        height: 56
      },
      onClick: handleUrl
    }, "Load")), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: "100%",
        height: 400,
        position: "relative"
      }
    }, url && /*#__PURE__*/_react["default"].createElement(_turingUi.HLSPlayer, {
      url: url,
      muted: true
    })));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { TextField, Button } from \"@material-ui/core\";\nimport { HLSPlayer } from \"turing-ui\";\n\nexport default () => {\n  const [url, setUrl] = useState(\n    \"https://test-guard.turingvideo.com/livestreaming/hls/4826/6b06ed3657da4df1b16f9b0ed80c249f/index.m3u8\"\n  );\n  const [input, setInput] = useState(\n    \"https://test-guard.turingvideo.com/livestreaming/hls/4826/6b06ed3657da4df1b16f9b0ed80c249f/index.m3u8\"\n  );\n\n  const handleInputChange = (e) => {\n    const value = e.target.value;\n    setInput(value);\n  };\n\n  const handleUrl = () => {\n    setUrl(\"\");\n    setTimeout(() => {\n      setUrl(input);\n    }, 3000);\n  };\n\n  return (\n    <>\n      <div style={{ marginBottom: 10 }}>\n        <TextField\n          variant=\"outlined\"\n          style={{ width: 800 }}\n          value={input}\n          onChange={handleInputChange}\n        />\n        <Button\n          variant=\"contained\"\n          color=\"primary\"\n          style={{ height: 56 }}\n          onClick={handleUrl}\n        >\n          Load\n        </Button>\n      </div>\n      <div style={{ width: \"100%\", height: 400, position: \"relative\" }}>\n        {url && <HLSPlayer url={url} muted />}\n      </div>\n    </>\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"@material-ui/core":{"version":"^4.11.3"},"turing-ui":{"version":"1.0.0"},"@types/react":{"version":"^16.8.6 || ^17.0.0"},"react-dom":{"version":"^16.12.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"hls-player","identifier":"hls-player-demo"},
  },
  'image-viewer-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _react = _interopRequireDefault(require("react"));

  var _turingUi = require("turing-ui");

  var _default = function _default() {
    var img = {
      id: "img1",
      key: "img1",
      url: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Finews.gtimg.com%2Fnewsapp_bt%2F0%2F14104391809%2F641&refer=http%3A%2F%2Finews.gtimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1637823361&t=74c09afea452055ec7f6e8f584a4bbfc"
    };
    return /*#__PURE__*/_react["default"].createElement(_turingUi.ImageViewer, {
      url: img.url,
      style: {
        cursor: "zoom-in",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        width: "auto",
        height: 400,
        border: "none",
        outline: "none",
        position: "relative",
        zIndex: 1
      },
      imgAttrs: {
        draggable: true,
        onDragStart: function onDragStart(event) {
          event.dataTransfer.setData("key", img.id || img.key || "");
        }
      }
    });
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { ImageViewer } from \"turing-ui\";\n\nexport default () => {\n  const img = {\n    id: \"img1\",\n    key: \"img1\",\n    url:\n      \"https://gimg2.baidu.com/image_search/src=http%3A%2F%2Finews.gtimg.com%2Fnewsapp_bt%2F0%2F14104391809%2F641&refer=http%3A%2F%2Finews.gtimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1637823361&t=74c09afea452055ec7f6e8f584a4bbfc\",\n  };\n\n  return (\n    <ImageViewer\n      url={img.url}\n      style={{\n        cursor: \"zoom-in\",\n        display: \"block\",\n        marginLeft: \"auto\",\n        marginRight: \"auto\",\n        width: \"auto\",\n        height: 400,\n        border: \"none\",\n        outline: \"none\",\n        position: \"relative\",\n        zIndex: 1,\n      }}\n      imgAttrs={{\n        draggable: true,\n        onDragStart: (event: React.DragEvent) => {\n          event.dataTransfer.setData(\"key\", img.id || img.key || \"\");\n        },\n      }}\n    />\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"turing-ui":{"version":"1.0.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.11.3"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.12.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"image-viewer","identifier":"image-viewer-demo"},
  },
  'message-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _react = _interopRequireDefault(require("react"));

  var _turingUi = require("turing-ui");

  var _core = require("@material-ui/core");

  var _default = function _default() {
    var handleSuccess = function handleSuccess() {
      _turingUi.message.success("success", 2000);
    };

    var handleError = function handleError() {
      _turingUi.message.error("Error");
    };

    var handleWarn = function handleWarn() {
      _turingUi.message.warning("Warn");
    };

    var handleInfo = function handleInfo() {
      _turingUi.message.info("Info");
    };

    return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: handleSuccess
    }, "Success")), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: handleError
    }, "Error")), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: handleWarn
    }, "Warn")), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: handleInfo
    }, "Info")));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { message } from \"turing-ui\";\nimport { Grid, Button } from \"@material-ui/core\";\n\nexport default () => {\n  const handleSuccess = () => {\n    message.success(\"success\", 2000);\n  };\n\n  const handleError = () => {\n    message.error(\"Error\");\n  };\n\n  const handleWarn = () => {\n    message.warning(\"Warn\");\n  };\n\n  const handleInfo = () => {\n    message.info(\"Info\");\n  };\n\n  return (\n    <Grid container>\n      <Grid item>\n        <Button onClick={handleSuccess}>Success</Button>\n      </Grid>\n      <Grid item>\n        <Button onClick={handleError}>Error</Button>\n      </Grid>\n      <Grid item>\n        <Button onClick={handleWarn}>Warn</Button>\n      </Grid>\n      <Grid item>\n        <Button onClick={handleInfo}>Info</Button>\n      </Grid>\n    </Grid>\n  );\n};"}},"dependencies":{"react":{"version":"^16.8.0 || ^17.0.0"},"turing-ui":{"version":"1.0.0"},"@material-ui/core":{"version":"^4.11.3"},"@date-io/moment":{"version":"1.x"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.8.0 || ^17.0.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"},"@types/react":{"version":"^16.8.6 || ^17.0.0"}},"componentName":"message","identifier":"message-demo"},
  },
  'modal-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _turingUi = require("turing-ui");

  var _core = require("@material-ui/core");

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)(""),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        open = _useState4[0],
        setOpen = _useState4[1];

    var handleConfirm = function handleConfirm() {
      console.log("confirm");
    };

    var onClose = function onClose() {
      console.log("close");
      setOpen(false);
    };

    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: 120
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: function onClick() {
        return setOpen(true);
      }
    }, "Open Modal"), /*#__PURE__*/_react["default"].createElement(_turingUi.Modal, {
      title: "Edit Camera",
      hideCancel: true,
      extraText: "*Required",
      onConfirm: handleConfirm,
      onClose: onClose,
      open: open
    }, /*#__PURE__*/_react["default"].createElement(_core.Grid, null, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
      value: state,
      required: true,
      onChange: function onChange(e) {
        return setState(e.target.value);
      },
      fullWidth: true,
      size: "small",
      variant: "outlined",
      label: "Camera name"
    }))));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { Modal } from \"turing-ui\";\nimport { Grid, TextField, Button } from \"@material-ui/core\";\n\nexport default () => {\n  const [state, setState] = useState(\"\");\n  const [open, setOpen] = useState(false);\n\n  const handleConfirm = () => {\n    console.log(\"confirm\");\n  };\n\n  const onClose = () => {\n    console.log(\"close\");\n    setOpen(false);\n  };\n\n  return (\n    <div style={{ width: 120 }}>\n      <Button onClick={() => setOpen(true)}>Open Modal</Button>\n      <Modal\n        title=\"Edit Camera\"\n        hideCancel\n        extraText=\"*Required\"\n        onConfirm={handleConfirm}\n        onClose={onClose}\n        open={open}\n      >\n        <Grid>\n          <TextField\n            value={state}\n            required\n            onChange={(e) => setState(e.target.value)}\n            fullWidth\n            size=\"small\"\n            variant=\"outlined\"\n            label=\"Camera name\"\n          />\n        </Grid>\n      </Modal>\n    </div>\n  );\n};"}},"dependencies":{"react":{"version":"^16.8.0 || ^17.0.0"},"turing-ui":{"version":"1.0.0"},"@material-ui/core":{"version":"^4.11.3"},"@date-io/moment":{"version":"1.x"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.8.0 || ^17.0.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"},"@types/react":{"version":"^16.8.6 || ^17.0.0"}},"componentName":"modal","identifier":"modal-demo"},
  },
  'pro-autocomplete-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _turingUi = require("turing-ui");

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)(""),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var vehicleMakeOptions = [{
      name: "Acura",
      value: "Acura",
      label: "Acura"
    }, {
      name: "Audi",
      value: "Audi",
      label: "Audi"
    }, {
      name: "BMW",
      value: "BMW",
      label: "BMW"
    }, {
      name: "Buick",
      value: "Buick",
      label: "Buick"
    }, {
      name: "Chevrolet",
      value: "Chevrolet",
      label: "Chevrolet"
    }, {
      name: "Chrysler",
      value: "Chrysler",
      label: "Chrysler"
    }, {
      name: "Dodge",
      value: "Dodge",
      label: "Dodge"
    }, {
      name: "FIAT",
      value: "FIAT",
      label: "FIAT"
    }, {
      name: "Ford",
      value: "Ford",
      label: "Ford"
    }, {
      name: "Honda",
      value: "Honda",
      label: "Honda"
    }, {
      name: "Hyundai",
      value: "Hyundai",
      label: "Hyundai"
    }, {
      name: "Mazda",
      value: "Mazda",
      label: "Mazda"
    }, {
      name: "Mercedes-Benz",
      value: "Mercedes-Benz",
      label: "Mercedes-Benz"
    }, {
      name: "Mitsubishi",
      value: "Mitsubishi",
      label: "Mitsubishi"
    }, {
      name: "Nissan",
      value: "Nissan",
      label: "Nissan"
    }, {
      name: "Toyota",
      value: "Toyota",
      label: "Toyota"
    }, {
      name: "Volkswagen",
      value: "Volkswagen",
      label: "Volkswagen"
    }, {
      name: "Volvo",
      value: "Volvo",
      label: "Volvo"
    }];
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: 300
      }
    }, /*#__PURE__*/_react["default"].createElement(_turingUi.ProAutocomplete, {
      onChange: function onChange(v) {
        return setState(v);
      },
      value: state,
      size: "small",
      options: vehicleMakeOptions,
      placeholder: "Search vehicle make"
    }));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { ProAutocomplete } from \"turing-ui\";\n\nexport default () => {\n  const [state, setState] = useState(\"\");\n\n  const vehicleMakeOptions = [\n    { name: \"Acura\", value: \"Acura\", label: \"Acura\" },\n    { name: \"Audi\", value: \"Audi\", label: \"Audi\" },\n    { name: \"BMW\", value: \"BMW\", label: \"BMW\" },\n    { name: \"Buick\", value: \"Buick\", label: \"Buick\" },\n    { name: \"Chevrolet\", value: \"Chevrolet\", label: \"Chevrolet\" },\n    { name: \"Chrysler\", value: \"Chrysler\", label: \"Chrysler\" },\n    { name: \"Dodge\", value: \"Dodge\", label: \"Dodge\" },\n    { name: \"FIAT\", value: \"FIAT\", label: \"FIAT\" },\n    { name: \"Ford\", value: \"Ford\", label: \"Ford\" },\n    { name: \"Honda\", value: \"Honda\", label: \"Honda\" },\n    { name: \"Hyundai\", value: \"Hyundai\", label: \"Hyundai\" },\n    { name: \"Mazda\", value: \"Mazda\", label: \"Mazda\" },\n    { name: \"Mercedes-Benz\", value: \"Mercedes-Benz\", label: \"Mercedes-Benz\" },\n    { name: \"Mitsubishi\", value: \"Mitsubishi\", label: \"Mitsubishi\" },\n    { name: \"Nissan\", value: \"Nissan\", label: \"Nissan\" },\n    { name: \"Toyota\", value: \"Toyota\", label: \"Toyota\" },\n    { name: \"Volkswagen\", value: \"Volkswagen\", label: \"Volkswagen\" },\n    { name: \"Volvo\", value: \"Volvo\", label: \"Volvo\" },\n  ];\n\n  return (\n    <div style={{ width: 300 }}>\n      <ProAutocomplete\n        onChange={(v) => setState(v)}\n        value={state}\n        size=\"small\"\n        options={vehicleMakeOptions}\n        placeholder=\"Search vehicle make\"\n      />\n    </div>\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"turing-ui":{"version":"1.0.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.11.3"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.12.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"pro-autocomplete","identifier":"pro-autocomplete-demo"},
  },
  'pro-select-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _turingUi = require("turing-ui");

  var _DirectionsWalk = _interopRequireDefault(require("@material-ui/icons/DirectionsWalk"));

  var _DirectionsCar = _interopRequireDefault(require("@material-ui/icons/DirectionsCar"));

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)(""),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        counter = _useState2[0],
        setCounter = _useState2[1];

    var _useState3 = (0, _react.useState)([]),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        options = _useState4[0],
        setOptions = _useState4[1];

    var option = [{
      label: "Counter 1",
      value: 0
    }, {
      label: "Counter 2",
      value: 1
    }, {
      label: "Counter 3",
      value: 2
    }, {
      label: "Counter 4",
      value: 3
    }, {
      label: "Counter 5",
      value: 4
    }];
    (0, _react.useEffect)(function () {
      setOptions(option);
    }, []);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_turingUi.ProSelect, {
      label: "Count",
      value: counter,
      options: options,
      onChange: function onChange(v) {
        return setCounter(v);
      }
    }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_turingUi.ProSelect, {
      preLabel: "Cnt" // label="Count"
      ,
      isSearch: true,
      startIcon: counter === 1 ? /*#__PURE__*/_react["default"].createElement(_DirectionsWalk["default"], null) : counter === 2 ? /*#__PURE__*/_react["default"].createElement(_DirectionsCar["default"], null) : null,
      value: counter,
      options: options,
      onChange: function onChange(v) {
        return setCounter(v);
      }
    }));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState, useEffect } from \"react\";\nimport { ProSelect } from \"turing-ui\";\nimport PersonIcon from \"@material-ui/icons/DirectionsWalk\";\nimport CarIcon from \"@material-ui/icons/DirectionsCar\";\n\nexport default () => {\n  const [counter, setCounter] = useState(\"\");\n  const [options, setOptions] = useState([]);\n\n  const option = [\n    { label: \"Counter 1\", value: 0 },\n    { label: \"Counter 2\", value: 1 },\n    { label: \"Counter 3\", value: 2 },\n    { label: \"Counter 4\", value: 3 },\n    { label: \"Counter 5\", value: 4 },\n  ];\n\n  useEffect(() => {\n    setOptions(option);\n  }, []);\n\n  return (\n    <>\n      <ProSelect\n        label=\"Count\"\n        value={counter}\n        options={options}\n        onChange={(v) => setCounter(v as string)}\n      />\n      <br />\n      <ProSelect\n        preLabel=\"Cnt\"\n        // label=\"Count\"\n        isSearch\n        startIcon={\n          counter === 1 ? <PersonIcon /> : counter === 2 ? <CarIcon /> : null\n        }\n        value={counter}\n        options={options}\n        onChange={(v) => setCounter(v as string)}\n      />\n    </>\n  );\n};"}},"dependencies":{"react":{"version":"^16.8.0 || ^17.0.0"},"turing-ui":{"version":"1.0.0"},"@material-ui/icons":{"version":"^4.11.2"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.0.0"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.8.0 || ^17.0.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"},"@types/react":{"version":"^16.8.6 || ^17.0.0"}},"componentName":"pro-select","identifier":"pro-select-demo"},
  },
  'select-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _turingUi = require("turing-ui");

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)(""),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        counter = _useState2[0],
        setCounter = _useState2[1];

    return /*#__PURE__*/_react["default"].createElement(_turingUi.Select, {
      style: {
        width: 120
      },
      noBorder: true,
      value: counter,
      options: [{
        label: "Counter 1",
        value: 0
      }, {
        label: "Counter 2",
        value: 1
      }, {
        label: "Counter 3",
        value: 2
      }, {
        label: "Counter 4",
        value: 3
      }, {
        label: "Counter 5",
        value: 4
      }],
      filter: false,
      size: "small",
      onChange: function onChange(v) {
        return setCounter(v);
      }
    });
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { Select } from \"turing-ui\";\n\nexport default () => {\n  const [counter, setCounter] = useState(\"\");\n\n  return (\n    <Select\n      style={{ width: 120 }}\n      noBorder\n      value={counter}\n      options={[\n        { label: \"Counter 1\", value: 0 },\n        { label: \"Counter 2\", value: 1 },\n        { label: \"Counter 3\", value: 2 },\n        { label: \"Counter 4\", value: 3 },\n        { label: \"Counter 5\", value: 4 },\n      ]}\n      filter={false}\n      size=\"small\"\n      onChange={(v) => setCounter(v as string)}\n    />\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"turing-ui":{"version":"1.0.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.11.3"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.12.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"select","identifier":"select-demo"},
  },
  'switch-buttons-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _turingUi = require("turing-ui");

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var tabOptions = [{
      label: "Select a Face",
      value: "select"
    }, {
      label: "Upload a Photo",
      value: "upload"
    }];

    var _useState = (0, _react.useState)("select"),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        tabKey = _useState2[0],
        setTabKey = _useState2[1];

    return /*#__PURE__*/_react["default"].createElement(_turingUi.SwitchButtons, {
      value: tabKey,
      onChange: function onChange(v) {
        return setTabKey(v);
      },
      options: tabOptions
    });
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { SwitchButtons } from \"turing-ui\";\n\nexport default () => {\n  const tabOptions = [\n    { label: \"Select a Face\", value: \"select\" },\n    { label: \"Upload a Photo\", value: \"upload\" },\n  ];\n\n  const [tabKey, setTabKey] = useState(\"select\");\n\n  return (\n    <SwitchButtons\n      value={tabKey}\n      onChange={(v) => setTabKey(v)}\n      options={tabOptions}\n    />\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"turing-ui":{"version":"1.0.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.11.3"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.12.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"switch-buttons","identifier":"switch-buttons-demo"},
  },
  'table-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _objectSpread2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2"));

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _turingUi = require("turing-ui");

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)({
      total: 30,
      current: 1,
      pageSize: 10
    }),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        pagination = _useState2[0],
        setPagination = _useState2[1];

    var columns = [{
      title: "Name",
      // eslint-disable-next-line react/display-name
      dataIndex: "name",
      render: function render(value, record) {
        return /*#__PURE__*/_react["default"].createElement("span", null, value);
      }
    }, {
      title: "Length",
      dataIndex: "length",
      render: function render(value, record) {
        return value;
      }
    }, {
      title: "Wait Time",
      dataIndex: "waitTime",
      sortable: true
    }];
    var list = [{
      id: 1,
      type: "counter",
      name: "Counter 1",
      length: 2,
      waitTime: "03:20"
    }, {
      id: 2,
      type: "counter",
      name: "Counter 2",
      length: 3,
      waitTime: "04:30"
    }, {
      id: 3,
      type: "counter",
      name: "Counter 3",
      length: 1,
      waitTime: "00:50"
    }, {
      id: 4,
      type: "counter",
      name: "Counter 4",
      length: 3,
      waitTime: "05:20"
    }, {
      id: 5,
      type: "counter",
      name: "Counter 5",
      length: 2,
      waitTime: "03:05"
    }, {
      id: 6,
      type: "checkout",
      name: "Self Checkout",
      length: 0,
      waitTime: "00:00"
    }];

    var handlePageChange = function handlePageChange(newPage, newPageSize) {
      console.log(newPage, newPageSize);
      setPagination((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, pagination), {}, {
        current: newPage - 1,
        pageSize: newPageSize
      }));
    };

    var handleClick = function handleClick(record) {
      console.log(record);
    };

    var handleSort = function handleSort(key, sort) {
      console.log(key, sort);
    };

    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_turingUi.Table, {
      dataSource: list,
      columns: columns,
      pagination: pagination,
      onChange: handlePageChange,
      onRowClick: handleClick,
      onSort: handleSort
    }));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { Table } from \"turing-ui\";\n\nexport default () => {\n  const [pagination, setPagination] = useState({\n    total: 30,\n    current: 1,\n    pageSize: 10,\n  });\n\n  const columns = [\n    {\n      title: \"Name\",\n      // eslint-disable-next-line react/display-name\n      dataIndex: \"name\",\n      render: (value: any, record: any): React.ReactNode => (\n        <span>{value}</span>\n      ),\n    },\n    {\n      title: \"Length\",\n      dataIndex: \"length\",\n      render: (value: any, record: any): string => value,\n    },\n    {\n      title: \"Wait Time\",\n      dataIndex: \"waitTime\",\n      sortable: true,\n    },\n  ];\n\n  const list = [\n    {\n      id: 1,\n      type: \"counter\",\n      name: \"Counter 1\",\n      length: 2,\n      waitTime: \"03:20\",\n    },\n    {\n      id: 2,\n      type: \"counter\",\n      name: \"Counter 2\",\n      length: 3,\n      waitTime: \"04:30\",\n    },\n    {\n      id: 3,\n      type: \"counter\",\n      name: \"Counter 3\",\n      length: 1,\n      waitTime: \"00:50\",\n    },\n    {\n      id: 4,\n      type: \"counter\",\n      name: \"Counter 4\",\n      length: 3,\n      waitTime: \"05:20\",\n    },\n    {\n      id: 5,\n      type: \"counter\",\n      name: \"Counter 5\",\n      length: 2,\n      waitTime: \"03:05\",\n    },\n    {\n      id: 6,\n      type: \"checkout\",\n      name: \"Self Checkout\",\n      length: 0,\n      waitTime: \"00:00\",\n    },\n  ];\n\n  const handlePageChange = (newPage: number, newPageSize: number) => {\n    console.log(newPage, newPageSize);\n    setPagination({\n      ...pagination,\n      current: newPage - 1,\n      pageSize: newPageSize,\n    });\n  };\n\n  const handleClick = (record: any) => {\n    console.log(record);\n  };\n\n  const handleSort = (key: string | number, sort: string) => {\n    console.log(key, sort);\n  };\n\n  return (\n    <div>\n      <Table\n        dataSource={list}\n        columns={columns}\n        pagination={pagination}\n        onChange={handlePageChange}\n        onRowClick={handleClick}\n        onSort={handleSort}\n      />\n    </div>\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"turing-ui":{"version":"1.0.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/core":{"version":"^4.11.3"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.12.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"table","identifier":"table-demo"},
  },
  'tooltip-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _react = _interopRequireDefault(require("react"));

  var _turingUi = require("turing-ui");

  var _core = require("@material-ui/core");

  var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

  var _default = function _default() {
    return /*#__PURE__*/_react["default"].createElement(_turingUi.Tooltip, {
      title: "Delete"
    }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, null, /*#__PURE__*/_react["default"].createElement(_Delete["default"], null)));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { Tooltip } from \"turing-ui\";\nimport { IconButton } from \"@material-ui/core\";\nimport DeleteIcon from \"@material-ui/icons/Delete\";\n\nexport default () => {\n  return (\n    <Tooltip title=\"Delete\">\n      <IconButton>\n        <DeleteIcon />\n      </IconButton>\n    </Tooltip>\n  );\n};"}},"dependencies":{"react":{"version":"^16.8.0 || ^17.0.0"},"turing-ui":{"version":"1.0.0"},"@material-ui/core":{"version":"^4.0.0"},"@material-ui/icons":{"version":"^4.11.2"},"@date-io/moment":{"version":"1.x"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-dom":{"version":"^16.8.0 || ^17.0.0"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"},"@types/react":{"version":"^16.8.6 || ^17.0.0"}},"componentName":"tooltip","identifier":"tooltip-demo"},
  },
  'webrtc-player-demo': {
    component: function DumiDemo() {
  var _interopRequireDefault = require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/interopRequireDefault");

  var _slicedToArray2 = _interopRequireDefault(require("/turing-ui/node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

  var _react = _interopRequireWildcard(require("react"));

  var _core = require("@material-ui/core");

  var _turingUi = require("turing-ui");

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  var _default = function _default() {
    var _useState = (0, _react.useState)("webrtc://dev-stream-go.turingvideo.com/live/1113/e9e2c1b13d974d73b38d0adfb064dc0c"),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        url = _useState2[0],
        setUrl = _useState2[1];

    var _useState3 = (0, _react.useState)("webrtc://dev-stream-go.turingvideo.com/live/1113/e9e2c1b13d974d73b38d0adfb064dc0c"),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        input = _useState4[0],
        setInput = _useState4[1];

    var handleInputChange = function handleInputChange(e) {
      var value = e.target.value;
      setInput(value);
    };

    var handleUrl = function handleUrl() {
      setUrl("");
      setTimeout(function () {
        setUrl(input);
      }, 3000);
    };

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
      variant: "outlined",
      style: {
        width: 800
      },
      value: input,
      onChange: handleInputChange
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      variant: "contained",
      color: "primary",
      style: {
        height: 56
      },
      onClick: handleUrl
    }, "Load")), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: "100%",
        height: 400,
        position: "relative"
      }
    }, url && /*#__PURE__*/_react["default"].createElement(_turingUi.WebrtcPlayer, {
      url: url,
      muted: true,
      autoplay: true
    })));
  };

  return _react["default"].createElement(_default);
},
    previewerProps: {"sources":{"_":{"tsx":"import React, { useState } from \"react\";\nimport { TextField, Button } from \"@material-ui/core\";\nimport { WebrtcPlayer } from \"turing-ui\";\n\nexport default () => {\n  const [url, setUrl] = useState(\n    \"webrtc://dev-stream-go.turingvideo.com/live/1113/e9e2c1b13d974d73b38d0adfb064dc0c\"\n  );\n  const [input, setInput] = useState(\n    \"webrtc://dev-stream-go.turingvideo.com/live/1113/e9e2c1b13d974d73b38d0adfb064dc0c\"\n  );\n\n  const handleInputChange = (e) => {\n    const value = e.target.value;\n    setInput(value);\n  };\n\n  const handleUrl = () => {\n    setUrl(\"\");\n    setTimeout(() => {\n      setUrl(input);\n    }, 3000);\n  };\n\n  return (\n    <>\n      <div style={{ marginBottom: 10 }}>\n        <TextField\n          variant=\"outlined\"\n          style={{ width: 800 }}\n          value={input}\n          onChange={handleInputChange}\n        />\n        <Button\n          variant=\"contained\"\n          color=\"primary\"\n          style={{ height: 56 }}\n          onClick={handleUrl}\n        >\n          Load\n        </Button>\n      </div>\n      <div style={{ width: \"100%\", height: 400, position: \"relative\" }}>\n        {url && <WebrtcPlayer url={url} muted autoplay />}\n      </div>\n    </>\n  );\n};"}},"dependencies":{"react":{"version":"^16.12.0"},"@material-ui/core":{"version":"^4.11.3"},"turing-ui":{"version":"1.0.0"},"@types/react":{"version":"^16.8.6 || ^17.0.0"},"react-dom":{"version":"^16.12.0"},"@date-io/moment":{"version":"1.x"},"@material-ui/icons":{"version":"^4.11.2"},"@material-ui/lab":{"version":"^4.0.0-alpha.57"},"@material-ui/pickers":{"version":"^3.3.10"},"hls.js":{"version":"0.14.17"},"moment":{"version":"^2.29.1"},"react-router-dom":{"version":"^5.2.0"},"react-text-mask":{"version":"^5.4.3"},"viewerjs":{"version":"^1.10.2"}},"componentName":"webrtc-player","identifier":"webrtc-player-demo"},
  },
};
